import * as React from "react";
import LabelCtl from "./LabelCtl";
import SelectCtl from "./SelectCtl";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import "./ExchangeItemCtl.scss";


interface IExchangeItemProps {
    quantity: number;
    title: string;
    exchangeProductNumber: string;
    index: number;
    exchangeList: ListItem[];
    onChange?: (productNumber: string, index: number) => void;
}

export default class ExchangeItemCtl extends React.PureComponent<IExchangeItemProps> {

    changeProduct = (productNumber: string) => {
        this.props.onChange?.(productNumber, this.props.index);
    };

    render() {
        return <div className={`exchangeRow${this.props.exchangeList.length === 0 ? "Hidden" : ""}`}>
                   <LabelCtl label={'(' + this.props.quantity + ') ' + this.props.title + ' exchanged for'} className="exchangeLabel" />
                   <SelectCtl value={this.props.exchangeProductNumber} items={this.props.exchangeList} onChange={this.changeProduct} className="exchangeSelect"
                              disabled={this.props.exchangeList.length === 1} hideItemValue={true} />
               </div>;
    }
}
